// PrintSafetyRecord.jsx
import React, { useEffect, useState } from 'react';
import './PrintQfRecord.less'; // 单独的打印样式
import * as CONF from "../../common/config";
import * as REQUEST from "../../common/request";
import moment from 'moment';

/** ================== 巡查项固定模板 ================== */
const CHECK_TEMPLATE = [
    { title: '安全负责人/管理员持证情况', options: '有,无' },
    { title: '“三合一”情况', options: '是,否' },
    { title: "违章搭建情况", options: '有,无' },
    { title: '特种设备持证情况', options: '有特种设备,无特种设备,有特种设备但无证' },
    { title: '消火栓，灭火器，指示标志保持完好有效', options: '是,否' },
    { title: '消防通道，灭火器周边，安全出口保持畅通', options: '是,否' },
    { title: '危化品存在使用情况', options: '有,无' },
    { title: '职业病危害情况', options: '有,无' },
    { title: '生产用电乱拉乱接及线路老化情况', options: '有,无' },
    { title: '食堂', options: '有食堂,无食堂,有食堂但无餐饮许可证' },
    { title: '液化气钢瓶', options: '有,无' },
    { title: '阀门及橡皮管老化', options: '有,无' },
    { title: '其他', options: '有,无' },

];
const PrintQfRecord = () => {
    const [recordData, setRecordData] = useState(null);

    const getList = async (id) => {
        console.log('id===', id);
        // data.page = data.page || 0;
        const result = await REQUEST.get({
            url: '/qfcheckfire/get',
            data: { id: id },
        });
        if (!result) return;
        setRecordData(result && result.data);
    };

    /** ================== 数据接收（保持你原有方式） ================== */
    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const dataStr = query.get('data');
        const data = JSON.parse(decodeURIComponent(dataStr));
        console.log('页面原始数据', data);
        getList(data);
    }, []);
    if (!recordData) return null;

    /** ================== 工具方法 ================== */
    const isChecked = (selected = '', option = '') => {
        if (!selected) return false;
        return selected
            .split(',')
            .map(s => s.trim())
            .includes(option);
    }

    const CheckedIcon = () => (
        <svg
            width="14"
            height="14"
            viewBox="0 0 16 16"
            style={{ marginRight: 4 }}
        >
            <rect
                x="0.75"
                y="0.75"
                width="14.5"
                height="14.5"
                fill="none"
                stroke="#000"
                strokeWidth="1.5"
            />
            <path
                d="M3 8.5 L6.5 12 L13 3.5"
                stroke="#000"
                strokeWidth="2"
                fill="none"
            />
        </svg>
    );

    const UnCheckedIcon = () => (
        <svg
            width="14"
            height="14"
            viewBox="0 0 16 16"
            style={{ marginRight: 4 }}
        >
            <rect
                x="0.75"
                y="0.75"
                width="14.5"
                height="14.5"
                fill="none"
                stroke="#000"
                strokeWidth="1.5"
            />
        </svg>
    );
    const renderOptions = (optionsStr, selected) => {
        const options = splitOptions(optionsStr);
        return (
            <span className="options">
                {options.map(opt => (
                    <span key={opt} className="option-item">
                        {isChecked(selected, opt) ? <CheckedIcon /> : <UnCheckedIcon />}
                        {opt}
                    </span>
                ))}
            </span>
        );
    };

    // 模板 + 实际数据合并
    const mergeChecklist = (template, checklist = []) =>
        template.map(tpl => {
            const exist = checklist.find(item => item.title === tpl.title);
            return {
                title: tpl.title,
                options: tpl.options,
                selected: exist?.selected || '',
                description: exist?.description || '',
                rectifyType: exist?.rectifyType || null,
                selectDate: exist?.selectDate || ''
            };
        });

    const finalChecklist = mergeChecklist(
        CHECK_TEMPLATE,
        recordData.checklist
    );

    /** ================== 处理情况自动生成 ================== */
    // 根据 rectifyType 获取对应的“第几项”
    const getItemIndexText = (type) => {
        const indexes = finalChecklist
            .map((item, index) => ({ ...item, index }))
            .filter(item => item.rectifyType === type)
            .map(item => item.index + 1);

        return indexes.length ? indexes.join('、') : '';
    };

    // 限期整改：获取序号 + 最早截止日期
    const getDelayInfo = () => {
        const delayItems = finalChecklist
            .map((item, index) => ({ ...item, index }))
            .filter(item => item.rectifyType === 2);

        if (!delayItems.length) {
            return {
                indexText: '',
                dateText: '',
            };
        }

        // 序号
        const indexText = delayItems
            .map(item => item.index + 1)
            .join('、');

        // 取最早的整改截止日期
        const dates = delayItems
            .map(item => item.selectDate)
            .filter(Boolean)
            .sort();

        let dateText = '';
        if (dates.length) {
            const d = new Date(dates[0]);
            dateText = `${d.getFullYear()} 年 ${String(d.getMonth() + 1).padStart(2, '0')} 月 ${String(d.getDate()).padStart(2, '0')} 日`;
        }

        return { indexText, dateText };
    };
    const normalize = str => (str || '').trim();

    const splitOptions = options =>
        normalize(options)
            .split(',')
            .map(o => o.trim())
            .filter(Boolean);

    const handleText = (() => {
        const rectifyNow = getItemIndexText(1);   // 当场整改
        const rectifyLater = getItemIndexText(2); // 限期整改
        const transfer = getItemIndexText(3);     // 移交处理

        const { indexText, dateText } = getDelayInfo();

        return (
            <>
                <div className="handle-line">
                    处理情况：
                </div>

                <div className="handle-line">
                    第 {rectifyNow || '____'} 项建议当场改正。
                </div>

                <div className="handle-line">
                    第 {rectifyLater || '____'} 项建议于  {dateText || '____ 年 ____ 月 ____ 日'} 前改正。
                </div>

                <div className="handle-line">
                    第 {transfer || '____'} 项移交相关职能部门处理。
                </div>
            </>
        );
    })();

    return (
        <div className="print-page">
            <div className="title">朱家角园区巡查单<span className="code">{recordData.code}</span></div>
            <table className="main-table">
                <tbody>
                    <tr>
                        <td colSpan="3">
                            被巡查单位（场所）名称：{recordData.companyInfo.companyName}
                        </td>
                        <td colSpan="2">
                            消防安全责任人：{recordData.companyInfo.safetyName}
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3">地址：{recordData.companyInfo.address}</td>
                        <td colSpan="2">电话：{recordData.companyInfo.safetyTel}</td>
                    </tr>

                    <tr>
                        <td colSpan="5" className="section-title">
                            巡查内容及存在隐患
                        </td>
                    </tr>

                    {finalChecklist.map((item, index) => (
                        <tr key={item.title}>
                            <td colSpan="5">
                                {index + 1}、{item.title}：
                                {renderOptions(item.options, item.selected)}
                                {item.description && (
                                    <span className="remark">（备注：{item.description}）</span>
                                )}
                            </td>
                        </tr>
                    ))}

                    {/* 处理情况（合并成一个大框） */}
                    <tr>
                        <td colSpan="5" className="handle-box">
                            {handleText}
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3">
                            负责人（签收人）：{recordData && recordData.checklist.length > 0 && <img className="qmimg" src={CONF.imgPrefix + recordData.checklist[0].compamy_sign}></img>}
                            <span className="date sdate">
                                {moment(recordData.checklist[0].createdAt).format('YYYY年MM月DD日')}
                            </span>
                        </td>
                        <td colSpan="2">
                            巡查人（签名）：
                            {recordData && recordData.checklist.length > 0 && <img className="qmimg" src={CONF.imgPrefix + recordData.checklist[0].jc_signature}></img>}
                            {recordData && recordData.checklist.length > 0 && <img className="qmimg" src={CONF.imgPrefix + recordData.checklist[0].jz_signature}></img>}
                            <span className="date">{moment(recordData.checklist[0].createdAt).format('YYYY年MM月DD日')}</span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div className="footer">
                （本巡查记录单一式二联，第一联镇消防安全委，第二联移交相关执法部门）
            </div>

        </div>
    );
};

export default PrintQfRecord;